export default __webpack_public_path__ + "static/contactuscover-e35c2300904ade4d29eb996ef6b167a0.png";